<template>
  <div>
    <b-card
      v-if="isInitialized"
      v-show="colorsInit"
      :style="{
        background: colorsConfig.backgroundColor,
        color: colorsConfig.mainTextColor,
      }"
      class="mt-4 mb-4"
    >
      <b-card-header>
        <b-row v-if="selectedOperation">
          <b-col>
            <h1>
              {{ $locales.t("selected_operation", "Wybrana operacja") }}:
              {{
                $locales.t(
                  "operation_names." + selectedOperationName,
                  selectedOperationName
                )
              }}
            </h1>
          </b-col>
        </b-row>
        <b-row v-else-if="selectedQueue">
          <b-col>
            <h1>
              {{ $locales.t("selected_operation", "Wybrana operacja") }}:
              {{
                $locales.t(
                  "queue_names." + selectedQueueName,
                  selectedQueueName
                )
              }}
            </h1>
          </b-col>
        </b-row>
        <b-row v-else-if="selectedLocalization">
          <b-col>
            <h1>
              {{ $locales.t("selected_operation", "Wybrana operacja") }}:
              {{
                $locales.t(
                  "localization_names." + selectedLocalizationName,
                  selectedLocalizationName
                )
              }}
            </h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg>
            <h1
              v-html="$locales.t('reservation_title', layout.reservationTitle)"
            ></h1>
            <h5>
              {{
                $locales.t(
                  "reservation_subtitle",
                  "W celu ustalenia wizyty wypełnij kolejne pola formularza"
                )
              }}
            </h5>
            <div
              class="text-over-steps"
              v-html="
                $locales.t('reservation_text_over_steps', layout.textOverSteps)
              "
            ></div>
          </b-col>
          <b-col
            v-if="reservationBlockEndIn"
            cols="12"
            lg="4"
            style="display: flex"
          >
            <i
              tabindex="0"
              v-b-tooltip.bottom
              class="fas fa-history fa-2x ml-auto mt-auto mb-auto"
              :title="
                $locales.t(
                  'time_for_session_end',
                  'Czas który pozostał do wygaśniecia sesji z blokadą rezerwacji'
                )
              "
            >
              {{
                $locales.t("reservation_lock_time", "Czas blokady rezerwacji")
              }}: {{ reservationBlockEndIn }}
            </i>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-alert v-if="globalError" show variant="danger">
          {{ globalError }}
        </b-alert>
        <form-wizard
          id="form-wizard"
          ref="formWizard"
          :color="colorsConfig.firstColor"
          :style="{ borderColor: colorsConfig.firstColor, fontSize: '1rem' }"
          :backButtonText="$locales.t('back_button_text', 'Cofnij')"
          :finishButtonText="
            $locales.t('finish_button_text', 'Potwierdź rezerwację')
          "
          :nextButtonText="$locales.t('next_button_text', 'Dalej')"
          subtitle="Podtytuł"
          title="Tytuł"
          @on-change="tabSwitch"
          @on-complete="completeForm"
        >
          <tab-content
            v-if="reservationSteps.localization"
            :title="$locales.t('Localization', 'Lokalizacja')"
            :before-change="beforeLocationChangeTab"
          >
            <b-row v-if="localizations.length == 0">
              <b-col>
                <h3>
                  {{
                    $locales.t(
                      "reservation_actual_not_available",
                      "Aktualnie nie ma możliwości umówienia wizyty. Spróbuj ponownie później."
                    )
                  }}
                </h3>
              </b-col>
            </b-row>
            <div v-else>
              <b-row
                v-for="localization in localizations"
                :key="localization.id"
              >
                <b-col class="mb-2" cols="12" lg="8" offset-lg="2">
                  <b-btn
                    :class="
                      selectedLocalization == localization.id ? 'active' : ''
                    "
                    :style="{
                      color: colorsConfig.fourthColor,
                      background: colorsConfig.secondColor,
                      border: isContrast ? '1px solid white' : '',
                    }"
                    block
                    class="p-2 operation-button"
                    @click="selectedLocalization = localization.id"
                    >{{
                      $locales.t(
                        "localization_names." + localization.name,
                        localization.name
                      )
                    }}</b-btn
                  >
                </b-col>
              </b-row>
            </div>
          </tab-content>
          <tab-content
            v-if="reservationSteps.queue"
            :title="$locales.t('queue', 'Kolejka')"
            :before-change="beforeQueueChangeTab"
          >
            <b-row v-if="queues.length == 0">
              <b-col>
                <h3>
                  {{
                    $locales.t(
                      "reservation_actual_not_available",
                      "Aktualnie nie ma możliwości umówienia wizyty. Spróbuj ponownie później."
                    )
                  }}
                </h3>
              </b-col>
            </b-row>
            <div v-else>
              <b-row v-for="queue in queues" :key="queue.id">
                <b-col class="mb-2" cols="12" lg="8" offset-lg="2">
                  <div v-if="!queue.dontShowOnReservationPage">
                    <b-btn
                      :class="selectedQueue == queue.id ? 'active' : ''"
                      :style="{
                        color: colorsConfig.fourthColor,
                        background: colorsConfig.secondColor,
                        border: isContrast ? '1px solid white' : '',
                      }"
                      block
                      class="p-2 operation-button"
                      @click="selectedQueue = queue.id"
                      >{{
                        $locales.t("queues_names." + queue.name, queue.name)
                      }}</b-btn
                    >
                  </div>
                </b-col>
              </b-row>
            </div>
          </tab-content>
          <tab-content
            v-if="reservationSteps.operation"
            :before-change="firstTabSwitch"
            :title="$locales.t('operation', 'Operacja')"
          >
            <h3>{{ $locales.t("select_operation", "Wybierz operację") }}</h3>
            <b-row v-for="operation in operations" :key="operation.id">
              <b-col class="mb-2" cols="12" lg="8" offset-lg="2">
                <div v-if="!operation.dontShowOnReservationPage">
                  <b-btn
                    :class="selectedOperation == operation.id ? 'active' : ''"
                    :style="{
                      color: colorsConfig.fourthColor,
                      background: colorsConfig.secondColor,
                      border: isContrast ? '1px solid white' : '',
                    }"
                    block
                    class="p-2 operation-button"
                    @click="selectedOperation = operation.id"
                    >{{
                      $locales.t(
                        "operation_names." + operation.name,
                        operation.name
                      )
                    }}</b-btn
                  >
                </div>
              </b-col>
            </b-row>
            <b-row v-if="operations.length == 0">
              <b-col>
                <h3>
                  {{
                    $locales.t(
                      "reservation_actual_not_available",
                      "Aktualnie nie ma możliwości umówienia wizyty. Spróbuj ponownie później."
                    )
                  }}
                </h3>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content
            :before-change="secondTabSwitch"
            :title="$locales.t('date_time', 'Data i czas')"
          >
            <h3>
              {{
                $locales.t(
                  "select_date_and_time",
                  "Wybierz dzień a następnie godzinę"
                )
              }}
            </h3>
            <b-row>
              <b-col class="pl-0 pr-0" cols="12" lg="4" md="6" offset-lg="2">
                <b-row style="white-space: pre-wrap">
                  <b-col
                    v-if="vCalendarDates.minDate != vCalendarDates.maxDate"
                  >
                    <h5 v-if="vCalendarDates.available.length > 0">
                      {{
                        $locales.t(
                          "reservation_available_from",
                          "Rezerwacje dostępne od"
                        )
                      }}:
                      {{ moment(vCalendarDates.minDate).format("DD.MM.YYYY") }}
                      {{ $locales.t("to", "do") }}
                      {{ moment(vCalendarDates.maxDate).format("DD.MM.YYYY") }}
                    </h5>
                    <h5 v-else>
                      {{
                        $locales.t(
                          "reservation_not_available_from",
                          "Brak dostępnych rezerwacji w okresie od"
                        )
                      }}
                      {{ moment(vCalendarDates.minDate).format("DD.MM.YYYY") }}
                      {{ $locales.t("to", "do") }}
                      {{ moment(vCalendarDates.maxDate).format("DD.MM.YYYY") }}
                    </h5>
                  </b-col>
                  <b-col v-else>
                    <h5>
                      {{
                        $locales.t(
                          "reservation_dates_not_available",
                          "Brak dostępnych terminów do rezerwacji"
                        )
                      }}
                    </h5>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <vc-date-picker
                      v-model="selectedDay"
                      :class="isContrast ? 'contrast-calendar' : ''"
                      :disabled-dates="vCalendarDates.disable"
                      :max-date="vCalendarDates.maxDate"
                      :min-date="vCalendarDates.minDate"
                      is-inline
                      mode="signle"
                      :locale="$locales.lang.actual"
                      timezone="Europe/Warsaw"
                    ></vc-date-picker>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" lg="4" md="6">
                <b-row>
                  <b-col>
                    <h4 v-if="selectedSlot">
                      {{
                        $locales.t(
                          "actual_selected_date",
                          "Aktualnie wybrana data rezerwacji"
                        )
                      }}:
                      {{
                        moment(selectedSlot.dateTime).format("DD/MM/YYYY HH:mm")
                      }}
                    </h4>
                    <b-btn
                      v-if="selectedSlot"
                      :style="{
                        background: colorsConfig.secondColor,
                        color: colorsConfig.fourthColor,
                      }"
                      block
                      class="mb-2"
                      variant="success"
                      @click="$refs.timePickerModal.open()"
                      >{{ $locales.t("change_time", "Zmień godzinę") }}</b-btn
                    >
                  </b-col>
                </b-row>
                <b-row
                  v-if="
                    reservationConfig &&
                    reservationConfig.captchaConfig.captchaEnable &&
                    reservationConfig.captchaConfig.hCaptchaEnable &&
                    selectedSlot
                  "
                >
                  <b-col>
                    <vue-hcaptcha
                      v-if="hCaptchaSiteKey"
                      ref="hCaptcha"
                      :sitekey="hCaptchaSiteKey"
                      @verify="validate"
                      :language="$locales.lang.actual"
                    ></vue-hcaptcha>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </tab-content>
          <tab-content
            v-if="reservationMode != 'ANONYMOUS'"
            :before-change="thirdTabSwitch"
            :title="$locales.t('data', 'Dane')"
          >
            <b-row>
              <b-col v-if="reservationMode == 'PERSONAL'" cols="12">
                <b-row v-for="property in properties" :key="property.id">
                  <b-col cols="12" lg="6" offset-lg="3">
                    <b-form-group
                      :label="
                        $locales.t(
                          'property_names.' + property.name,
                          property.name
                        )
                      "
                      :label-for="'prop_' + property.id.toString()"
                      label-cols="4"
                    >
                      <b-form-input
                        :id="'prop_' + property.id.toString()"
                        v-model="property.value"
                        v-validate="getValidateForProperty(property)"
                        :name="property.name"
                        :value="property.value"
                        :aria-label="
                          $locales.t(
                            'property_names.' + property.name,
                            property.name
                          )
                        "
                        class="property-input"
                      ></b-form-input>
                      <span class="property-error">
                        {{ errors.first(property.name) }}
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-if="reservationMode == 'ANONYMOUS'" cols="12">
                <b-row>
                  <b-col cols="12">
                    <h3>
                      {{
                        $locales.t(
                          "reservation_anonymous",
                          "Rezerwacja anonimowa"
                        )
                      }}
                    </h3>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <p>
                      {{
                        $locales.t(
                          "reservation_anonymous_description",
                          "Tworząc rezerwację w tym systemie nie musisz podawać danych osobowych"
                        )
                      }}
                    </p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-if="reservationMode == 'MIXED'" cols="12" md="6">
                <b-row>
                  <b-col cols="12">
                    <h3>
                      {{
                        $locales.t(
                          "type_reservation_data",
                          "Podaj dane wymagane do rezerwacji"
                        )
                      }}
                    </h3>
                  </b-col>
                </b-row>
                <b-row v-for="property in properties" :key="property.id">
                  <b-col cols="12" lg="6" md="12" offset-lg="3">
                    <b-form-group
                      :label="
                        $locales.t(
                          'property_names.' + property.name,
                          property.name
                        )
                      "
                      :label-for="'prop_' + property.id.toString()"
                      label-cols="4"
                    >
                      <b-form-input
                        :id="'prop_' + property.id.toString()"
                        v-model="property.value"
                        v-validate="getValidateForProperty(property)"
                        :name="property.name"
                        class="property-input"
                        :aria-label="
                          $locales.t(
                            'property_names.' + property.name,
                            property.name
                          )
                        "
                      ></b-form-input>
                      <span class="property-error">
                        {{ errors.first(property.name) }}
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-if="reservationMode == 'MIXED'" cols="12" md="6">
                <b-row>
                  <b-col cols="12">
                    <h3>
                      {{
                        $locales.t(
                          "reservation_anonymous",
                          "Rezerwacja anonimowa"
                        )
                      }}
                    </h3>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <p>
                      {{
                        $locales.t(
                          "reservation_anonymouse_warning",
                          "Jeżeli nie chcesz podawać swoich danych osobowych, możesz stworzyć rezerwację anonimowo, lecz wtedy
                                            nie uzyskasz żadnych powiadomień email"
                        )
                      }}
                    </p>
                  </b-col>
                </b-row>
                <b-btn
                  :style="{
                    background: colorsConfig.secondColor,
                    color: colorsConfig.fourthColor,
                  }"
                  block
                  class="mb-2"
                  size="lg"
                  variant="danger"
                  @click="anonymousReservation"
                  >{{
                    $locales.t(
                      "reservation_anonymous_button",
                      "Rezerwuję anonimowo"
                    )
                  }}</b-btn
                >
              </b-col>
            </b-row>
          </tab-content>
          <tab-content
            :before-change="finishTabSwitch"
            :title="
              $locales.t('regulations_and_confirm', 'Regulamin i potwierdzenie')
            "
          >
            <b-row>
              <b-col>
                <h3>{{ $locales.t("reservation_data", "Dane rezerwacji") }}</h3>
              </b-col>
            </b-row>
            <b-row class="property-info">
              <b-col cols="12" lg="2" style="font-size: 1rem"
                >{{
                  $locales.t("selected_operation", "Wybrana operacja")
                }}:</b-col
              >
              <b-col cols="12" lg="10" style="font-size: 1rem">
                {{
                  $locales.t(
                    "operation_names." + getTokenData().operationName,
                    getTokenData().operationName
                  )
                }}
              </b-col>
            </b-row>
            <hr />
            <b-row class="property-info">
              <b-col cols="12" lg="2" style="font-size: 1rem"
                >{{ $locales.t("date_time", "Data i czas") }}:</b-col
              >
              <b-col cols="12" lg="10" style="font-size: 1rem">
                {{
                  moment(
                    new Date(parseInt(getTokenData().reservationDate))
                  ).format("DD/MM/YYYY HH:mm")
                }}
              </b-col>
            </b-row>
            <hr />
            <b-row v-if="!isAnonymous">
              <b-col>
                <div v-for="property in properties" :key="property.id">
                  <b-row class="property-info">
                    <b-col cols="12" lg="2"
                      >{{
                        $locales.t(
                          "property_names." + property.name,
                          property.name
                        )
                      }}:</b-col
                    >
                    <b-col cols="12" lg="10">{{ property.value }}</b-col>
                  </b-row>
                  <hr />
                </div>
              </b-col>
            </b-row>
            <div v-if="regulations" class="mt-3">
              <b-row>
                <b-col>
                  <h3>
                    {{ $locales.t("regulation_title", regulations.title) }}
                  </h3>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <p
                    class="ml-3 mr-3 regulation-content"
                    v-html="
                      $locales.t('regulation_content_html', regulations.content)
                    "
                  ></p>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <h4>
                    {{ $locales.t("regulation_footer", regulations.footer) }}
                  </h4>
                </b-col>
              </b-row>
              <b-row v-if="reservationConfig.sendDocumentMustAccept">
                <b-col>
                  <b-form-checkbox
                    button-variant="red"
                    v-model="allowSendDocument"
                    :style="{
                      color: colorsConfig.regulationsAcceptanceColorOfText,
                      backgroundColor:
                        colorsConfig.regulationsAcceptanceBackgroundColorOfText,
                      fontWeight: layout.regulationsAcceptanceTextWeight,
                    }"
                  >
                    {{
                      $locales.t(
                        "allow_send_document",
                        reservationConfig.sendDocumentCheckboxLabel
                      )
                    }}
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row
                v-if="
                  !allowSendDocument && reservationConfig.sendDocumentMustAccept
                "
              >
                <b-col>
                  <span style="color: red">{{
                    $locales.t(
                      "send_document_accept_required",
                      "*Wymagana akceptacja"
                    )
                  }}</span>
                </b-col>
              </b-row>
              <b-row v-if="regulations.mustAccept">
                <b-col>
                  <b-form-checkbox
                    v-model="acceptRegulations"
                    :style="{
                      color: colorsConfig.regulationsAcceptanceColorOfText,
                      backgroundColor:
                        colorsConfig.regulationsAcceptanceBackgroundColorOfText,
                      fontWeight: layout.regulationsAcceptanceTextWeight,
                    }"
                    >{{
                      $locales.t("regulation_accept", regulations.checkBoxLabel)
                    }}</b-form-checkbox
                  >
                </b-col>
              </b-row>
              <b-row v-if="!acceptRegulations && regulations.mustAccept">
                <b-col>
                  <span style="color: red">{{
                    $locales.t(
                      "regulation_accept_required",
                      "*Wymagana akceptacja"
                    )
                  }}</span>
                </b-col>
              </b-row>
            </div>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div v-if="!props.isLastStep">
              <b-row>
                <b-col cols="12" lg="2" offset-lg="10">
                  <b-btn
                    v-if="
                      operations.length > 0 ||
                      localizations.length > 0 ||
                      queues.length > 0
                    "
                    :style="{
                      backgroundColor: colorsConfig.firstColor,
                      color: colorsConfig.thirdColor,
                    }"
                    block
                    class="footer-btn"
                    size="lg"
                    @click="$refs.formWizard.nextTab()"
                    :disabled="nextDisabled"
                    >{{ $locales.t("next_button_text", "Dalej") }}</b-btn
                  >
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <b-row v-if="smsCodeBeforeConfirmNeeded">
                <b-col cols="12" lg="4" offset-lg="3">
                  <b-form-group
                    :label="
                      $locales.t(
                        'type_sms_code',
                        'Wprowadź kod otrzymany SMS\'em'
                      )
                    "
                  >
                    <b-form-input v-model="smsCode"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="d-flex" cols="12" lg="2">
                  <b-btn
                    variant="outline-secondary"
                    class="mt-auto mb-auto"
                    @click="sendSmsCode"
                    >{{
                      $locales.t(
                        "code_not_receive_button",
                        "Nie otrzymałem kodu"
                      )
                    }}</b-btn
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6" offset-lg="3">
                  <b-btn
                    v-if="operations.length > 0"
                    :style="{
                      backgroundColor: colorsConfig.firstColor,
                      color: colorsConfig.thirdColor,
                    }"
                    block
                    class="footer-btn"
                    size="lg"
                    @click="$refs.formWizard.nextTab()"
                    :disabled="!finishTabSwitch()"
                    >{{
                      $locales.t("finish_button_test", "Potwierdź rezerwację")
                    }}</b-btn
                  >
                </b-col>
              </b-row>
            </div>
          </template>
        </form-wizard>
      </b-card-body>
    </b-card>

    <sweet-modal
      ref="timePickerModal"
      :modal-theme="isContrast ? 'dark' : 'light'"
      :style="sweetModalStyle"
      overlay-theme="dark"
    >
      <b-alert v-if="slotBlockedError" show variant="danger">
        {{ slotBlockedError }}
      </b-alert>
      <label for="selectTime">
        <h3>{{ $locales.t("select_time", "Wybierz godzinę") }}:</h3>
      </label>
      <b-select
        id="selectTime"
        v-model="selectedSlot"
        :options="selectOptionsSlots"
        class="text-center"
        :aria-label="$locales.t('select_time', 'Wybierz godzinę')"
        name="selectTime"
      ></b-select>
    </sweet-modal>
    <sweet-modal
      ref="continueReservationModal"
      :modal-theme="isContrast ? 'dark' : 'light'"
      :style="sweetModalStyle"
      blocking
      hide-close-button
      overlay-theme="dark"
    >
      <h3>
        {{
          $locales.t(
            "already_reservation_modal_title",
            "Posiadasz już rozpoczętą rezerwację, czy chcesz ją dokończyć?"
          )
        }}
      </h3>
      <b-row>
        <b-col class="p-2" cols="12" lg="5" offset-lg="1">
          <b-btn
            :disabled="disalbeModalBtn"
            :style="{
              fontSize: '1rem',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              background: isContrast ? 'white' : '',
              color: isContrast ? 'black' : '',
            }"
            block
            size="lg"
            variant="success"
            @click="continueReservation"
            :aria-label="
              $locales.t(
                'continue_reservation_button',
                'Chcę dokończyć rezerwację'
              )
            "
            >{{
              $locales.t(
                "continue_reservation_button",
                "Chcę dokończyć rezerwację"
              )
            }}</b-btn
          >
        </b-col>
        <b-col class="p-2" cols="12" lg="5">
          <b-btn
            :disabled="disalbeModalBtn"
            :style="{
              fontSize: '1rem',
              whiteSpace: 'pre-wrap',
              overflowWrap: 'break-word',
              background: isContrast ? 'white' : '',
              color: isContrast ? 'black' : '',
            }"
            block
            size="lg"
            variant="primary"
            @click="reset"
            :aria-label="
              $locales.t(
                'start_new_reservation_button',
                'Chcę stworzyć nową rezerwację'
              )
            "
            >{{
              $locales.t(
                "start_new_reservation_button",
                "Chcę stworzyć nową rezerwację"
              )
            }}</b-btn
          >
        </b-col>
      </b-row>
    </sweet-modal>
    <sweet-modal
      ref="reservationTimoutModal"
      :modal-theme="isContrast ? 'dark' : 'light'"
      :style="sweetModalStyle"
      blocking
      hide-close-button
      overlay-theme="dark"
    >
      <h3>{{ $locales.t("session_end", "Twoja sesja wygasła") }}</h3>
      <b-btn
        :style="{
          fontSize: '1rem',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          background: isContrast ? 'white' : '',
          color: isContrast ? 'black' : '',
        }"
        size="lg"
        variant="primary"
        @click="reset"
        >{{ $locales.t("start_new_session", "Rozpocznij od nowa") }}</b-btn
      >
    </sweet-modal>

    <sweet-modal
      ref="customMessageModal"
      :modal-theme="isContrast ? 'dark' : 'light'"
      :style="sweetModalStyle"
      blocking
      hide-close-button
      overlay-theme="dark"
    >
      <h3>{{ customMessageForModal }}</h3>
      <br />
      <b-btn
        :style="{
          fontSize: '1rem',
          whiteSpace: 'pre-wrap',
          overflowWrap: 'break-word',
          background: isContrast ? 'white' : '',
          color: isContrast ? 'black' : '',
        }"
        size="lg"
        variant="primary"
        @click="reset"
        >{{ $locales.t("start_new_session", "Rozpocznij od nowa") }}</b-btn
      >
    </sweet-modal>
    <message-dialog ref="messageDialog"></message-dialog>
    <sweet-modal
      width="400"
      ref="hCaptchaModal"
      :modal-theme="isContrast ? 'dark' : 'light'"
      :style="sweetModalStyle"
      class="hCaptchaModal"
      blocking
      overlay-theme="dark"
    >
      <h3>Wymagana dodatkowa weryfikacja</h3>
      <vue-hcaptcha
        v-if="hCaptchaSiteKey"
        ref="hCaptchaBeforeCalendar"
        :sitekey="hCaptchaSiteKey"
        @verify="validateBeforeCalendar"
        :language="$locales.lang.actual"
      ></vue-hcaptcha>
    </sweet-modal>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { pl, en } from "vuejs-datepicker/dist/locale";
import { SweetModal } from "sweet-modal-vue";
import moment, { relativeTimeThreshold } from "moment";
import "moment/locale/pl";
import { getTokenData } from "@/utils/helpers";
import {
  captchaV2Key,
  hCaptchaKey,
  getCompanyNameFromConfig,
} from "@/utils/appSettings";
import router from "@/router";
import MessageDialog from "@/components/MessageDialog";
import VueHcaptcha from "@/components/hcaptcha";

export default {
  name: "reservation",
  metaInfo: {
    title: "Umawianie wizyt",
  },
  components: {
    Datepicker,
    SweetModal,
    MessageDialog,
    VueHcaptcha,
  },
  data() {
    return {
      hCaptchaSiteKey: null,
      captchaV2SiteKey: null,
      captchaV2Config: false,
      captchaV2Token: "",
      hCapchaTokenBeforeCalendar: "",
      properties: [],
      pl: pl,
      en: en,
      selectedOperation: null,
      selectedSlot: null,
      availableSlots: [],
      disabledDates: {
        to: new Date(),
        from: new Date(),
        dates: [],
      },
      selectedDay: null,
      isInitialized: false,
      regulations: null,
      selectOptionsSlots: [],
      slotBlockedError: "",
      reservationMode: null,
      isAnonymous: false,
      globalError: null,
      acceptRegulations: false,
      disalbeModalBtn: false,
      colorsConfig: null,
      reservationBlockEndIn: null,
      reservationBlockInterval: null,
      colorsInit: false,
      customMessageForModal: "",
      vCalendarDates: {
        available: [],
        disable: [Date.now()],
        minDate: Date.now(),
        maxDate: Date.now(),
      },
      sweetModalStyle: {},
      tempColors: {},
      smsCodeBeforeConfirmNeeded: false,
      smsCode: "",
      continuedReservation: false,
      isConfirmed: false,
      reservationConfig: null,
      allowSendDocument: false,
      reservationSteps: null,
      selectedQueue: null,
      selectedLocalization: null,
      localizations: [],
      hCapchaVerifyAction: null,
      currentTabIndex: 0,
    };
  },

  computed: {
    nextDisabled() {
      if (this.stepsCount - 2 == this.currentTabIndex) {
        return !this.selectedSlot;
      }

      return false;
    },
    lastStepId() {
      let lastStepId = 0;
      if (!this.reservationSteps) {
        return lastStepId;
      }
      switch (this.reservationSteps.reservationAssignTo) {
        case 0: {
          lastStepId = this.selectedOperation;
          break;
        }
        case 1: {
          lastStepId = this.selectedQueue;
          break;
        }
        case 2: {
          lastStepId = this.selectedLocalization;
          break;
        }
      }
      return lastStepId;
    },
    queues() {
      if (this.reservationSteps.localization) {
        if (!this.selectedLocalization) {
          return [];
        }

        var find = this.localizations.find(
          (el) => el.id === this.selectedLocalization
        );
        const any = find?.queues.some((o) => !o.displayPriorityInReservation);

        if (!any) {
          return (
            find?.queues.sort((a, b) =>
              a.displayPriorityInReservation > b.displayPriorityInReservation
                ? 1
                : -1
            ) ?? []
          );
        }
        return (
          find?.queues.sort((a, b) => (a.webAdminId > b.webAdminId ? 1 : -1)) ??
          []
        );
      }
      const queues = this.localizations
        .map((el) => el.queues)
        .reduce((a, b) => a.concat(b), []);

      const any = queues.some((o) => !o.displayPriorityInReservation);

      if (!any) {
        return queues.sort((a, b) =>
          a.displayPriorityInReservation > b.displayPriorityInReservation
            ? 1
            : -1
        );
      }
      return queues.sort((a, b) => (a.webAdminId > b.webAdminId ? 1 : -1));
      //return this.localizations.map(el=>el.queues).reduce((a,b) => a.concat(b), []);
    },
    operations() {
      if (this.reservationSteps.queue) {
        if (!this.selectedQueue) {
          return [];
        }

        var find = this.queues.find((el) => el.id === this.selectedQueue);
        const any = find?.operations.some(
          (o) => !o.displayPriorityInReservation
        );

        if (!any) {
          return (
            find?.operations.sort((a, b) =>
              a.displayPriorityInReservation > b.displayPriorityInReservation
                ? 1
                : -1
            ) ?? []
          );
        }
        return (
          find?.operations.sort((a, b) =>
            a.webAdminId > b.webAdminId ? 1 : -1
          ) ?? []
        );
      }
      const operations = this.queues
        .map((el) => el.operations)
        .reduce((a, b) => a.concat(b), []);
      const any = operations.some((o) => !o.displayPriorityInReservation);

      if (!any) {
        return operations.sort((a, b) =>
          a.displayPriorityInReservation > b.displayPriorityInReservation
            ? 1
            : -1
        );
      }

      return operations.sort((a, b) => (a.webAdminId > b.webAdminId ? 1 : -1));
      //return this.queues.map(el=>el.operations).reduce((a,b)=> a.concat(b), []);
    },
    layout() {
      return this.$store.getters.layoutConfig;
    },
    stepsCount() {
      if (!this.reservationSteps) {
        return 3;
      }
      let steps = 2;

      if (this.reservationSteps.localization) {
        steps++;
      }

      if (this.reservationSteps.queue) {
        steps++;
      }

      if (this.reservationSteps.operation) {
        steps++;
      }

      return steps;
    },
    companyName: function () {
      return this.$store.getters.getCompanyName;
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    isContrast: function () {
      return this.contrast != "none";
    },
    selectedLocalizationName() {
      const localization = this.localizations.find(
        (el) => el.id === this.selectedLocalization
      );
      return localization?.name ?? "";
    },
    selectedQueueName() {
      const queue = this.queues.find((el) => el.id === this.selectedQueue);
      return queue?.name ?? "";
    },
    selectedOperationName() {
      const operation = this.operations.find((element) => {
        return element.id == this.selectedOperation;
      });
      if (operation) {
        return operation.name;
      }
      return "";
    },
    minAvailableDate: function () {
      var vm = this;
      return new Date(
        Math.min.apply(
          null,
          vm.vCalendarDates.available.map(function (date) {
            return new Date(date);
          })
        )
      );
    },
    maxAvailableDate: function () {
      var vm = this;
      return new Date(
        Math.max.apply(
          null,
          vm.vCalendarDates.available.map(function (date) {
            return new Date(date);
          })
        )
      );
    },
    contrast: function () {
      return this.$store.getters.getContrast;
    },
  },
  watch: {
    selectedSlot: function (newVal) {
      var vm = this;
      if (newVal) {
        vm.slotBlockedError = "";
        vm.$refs.timePickerModal.close();
      }
    },
    selectedOperation(newVal) {
      if (newVal > 0) {
        this.selectedDay = null;
        this.selectedSlot = null;
        this.vCalendarDates = {
          available: [],
          disable: [Date.now()],
          minDate: Date.now(),
          maxDate: Date.now(),
        };
        this.getAvailableDates();
      }
    },
    selectedLocalization(newVal) {
      this.selectedQueue = null;
      if (!this.reservationSteps || !newVal) {
        return;
      }
      if (this.reservationSteps.reservationAssignTo == 2) {
        this.getAvailableDates();
      }
    },
    selectedQueue(newVal) {
      this.selectedOperation = null;
      if (!this.reservationSteps || !newVal) {
        return;
      }
      if (this.reservationSteps.reservationAssignTo == 1) {
        this.getAvailableDates();
      }
    },
    selectedDay: function (newVal) {
      if (newVal) {
        this.dayClick({ date: newVal });
      }
    },
    contrast: function (newVal) {
      if (newVal == "none") {
        this.getColorsConfig();
      } else {
        this.setContrast();
      }
    },
  },
  methods: {
    validate(params) {
      this.captchaV2Token = params;
    },
    validateBeforeCalendar(params) {
      this.hCapchaTokenBeforeCalendar = params;
      if (this.hCapchaVerifyAction) {
        this.hCapchaVerifyAction(params);
      }
      this.$refs.hCaptchaModal.close();
    },
    moment,
    getTokenData,
    dayClick(day) {
      this.refreshSlots(new Date(day.date));
    },
    reset() {
      var vm = this;
      sessionStorage.removeItem("token");
      this.$router
        .push({
          name: "Reservation",
          params: { companyName: vm.companyName },
        })
        .finally(() => {
          this.$store.dispatch("setKey");
        });
    },
    showCustomMessage(type, msg) {
      this.$refs.messageDialog.show(type, msg);
    },
    async completeForm() {
      var vm = this;
      if (vm.smsCodeBeforeConfirmNeeded) {
        if (!vm.smsCode) {
          vm.$refs.messageDialog.show(
            "warn",
            vm.$locales.t("type_sms_code", "Wprowadź kod otrzymany SMS'em")
          );
        }
        if (!(parseInt(vm.smsCode) > 0)) {
          vm.$refs.messageDialog.show(
            "warn",
            vm.$locales.t("wrong_sms_format", "Niepoprawny format kodu SMS")
          );
        }
      }
      var captchaToken = "fakeToken";
      if (vm.reservationConfig.captchaConfig.captchaEnable) {
        captchaToken = await vm.$recaptcha("ConfirmReservation");
      }
      try {
        vm.$http
          .post("Slot/ConfirmReservation", {
            captchaToken: captchaToken,
            isAnonymous: vm.isAnonymous,
            smsCode: vm.smsCode,
            allowSendDocument: vm.allowSendDocument,
          })
          .then(async (response) => {
            if (response.data) {
              vm.isConfirmed = true;
              await vm.$http
                .get(`Authentication/GetEmptyToken/${vm.companyName}`)
                .then((response) => {
                  sessionStorage.setItem("token", response.data.token);
                });

              clearInterval(vm.reservationBlockInterval);
              if (!getCompanyNameFromConfig()) {
                router.push({
                  path: `/${vm.companyName}/Info/${response.data}`,
                });
              } else {
                router.push({
                  path: `/Info/${response.data}`,
                });
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              if (
                error.response.data.toLowerCase() ==
                "error while verify captcha"
              ) {
                vm.showCustomMessage(
                  "error",
                  vm.$locales.t(
                    "verify_captcha_error",
                    "Wystąpił błąd weryfikacji captcha"
                  )
                );
              } else if (
                error.response.data.toLowerCase() == "properties not unique"
              ) {
                vm.showCustomMessage(
                  "warn",
                  vm.$locales.t(
                    "limit_reservation_error",
                    "Wykorzystałeś limit swoich rezerwacji do wybranej operacji"
                  )
                );
              } else if (
                error.response.data.toLowerCase() == "validator error"
              ) {
                vm.showCustomMessage(
                  "error",
                  vm.$locales.t(
                    "validate_data_error",
                    "Błąd walidacji wprowadzonych danych"
                  )
                );
              } else if (
                error.response.data.toLowerCase() ==
                "limit of reservations for this phone number reached"
              ) {
                vm.showCustomMessage(
                  "warn",
                  vm.$locales.t(
                    "phone_number_limit_error",
                    "Wykorzystałeś limit rezerwacji na ten numer telefonu"
                  )
                );
              } else if (
                error.response.data.toLowerCase() == "invalid sms confirm code"
              ) {
                vm.showCustomMessage(
                  "warn",
                  vm.$locales.t("wrong_sms_code", "Niepoprawny kod SMS")
                );
              } else if (
                error.response.data.toLowerCase() == "same ip required"
              ) {
                vm.showCustomMessage(
                  "same_ip_error",
                  "Twoje IP zmieniło się w trakcie procesu rezerwacji"
                );
              } else {
                vm.showCustomMessageBasedOnError(error);
              }
            }
          });
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          vm.$http
            .post("Slot/ConfirmReservation", {
              captchaToken: "",
              isAnonymous: vm.isAnonymous,
              smsCode: vm.smsCode,
              allowSendDocument: vm.allowSendDocument,
            })
            .then(async (response) => {
              if (response.data) {
                await vm.$http
                  .get(`Authentication/GetEmptyToken/${vm.companyName}`)
                  .then((response) => {
                    sessionStorage.setItem("token", response.data.token);
                  });
                clearInterval(vm.reservationBlockInterval);
                router.push({
                  path: `/${vm.companyName}/Info/${response.data}`,
                });
              }
            })
            .catch((error) => {
              if (error.response && error.response.data) {
                if (
                  error.response.data.toLowerCase() ==
                  "error while verify captcha"
                ) {
                  vm.showCustomMessage(
                    "error",
                    vm.$locales.t(
                      "verify_captcha_error",
                      "Wystąpił błąd weryfikacji captcha"
                    )
                  );
                }
                if (
                  error.response.data.toLowerCase() == "properties not unique"
                ) {
                  vm.showCustomMessage(
                    "warn",
                    vm.$locales.t(
                      "limit_reservation_error",
                      "Wykorzystałeś limit swoich rezerwacji do wybranej operacji"
                    )
                  );
                }
                if (error.response.data.toLowerCase() == "validator error") {
                  vm.showCustomMessage(
                    "error",
                    vm.$locales.t(
                      "validate_data_error",
                      "Błąd walidacji wprowadzonych danych"
                    )
                  );
                }
                if (
                  error.response.data.toLowerCase() ==
                  "limit of reservations for this phone number reached"
                ) {
                  vm.showCustomMessage(
                    "warn",
                    vm.$locales.t(
                      "phone_number_limit_error",
                      "Wykorzystałeś limit rezerwacji na ten numer telefonu"
                    )
                  );
                }
                if (
                  error.response.data.toLowerCase() ==
                  "invalid sms confirm code"
                ) {
                  vm.showCustomMessage(
                    "warn",
                    vm.$locales.t("wrong_sms_code", "Niepoprawny kod SMS")
                  );
                }
              }
            });
        }
      }
    },
    getValidateForProperty(property) {
      var vm = this;
      var result = "";
      property.validations.forEach((validation) => {
        if (!result == "") {
          result += "|";
        }
        switch (validation.type) {
          case 0: {
            break;
          }
          case 1: {
            result += "numeric";
            break;
          }
          case 2: {
            result += "email|noascii";
            break;
          }
          case 3: {
            result += "phoneNumber";
            break;
          }
          case 4: {
            result += "required";
            break;
          }
          case 5: {
            result += `regex:${validation.value}`;
            break;
          }
          case 6: {
            result += `min:${validation.value}`;
            break;
          }
          case 7: {
            result += `max:${validation.value}`;
            break;
          }
        }
      });
      return result;
    },
    async getRecaptcha(name) {
      return await new Promise(async (resolve, reject) => {
        var iteration = 0;
        while (true) {
          try {
            if (iteration >= 10) {
              this.$refs.messageDialog.show(
                "warn",
                "Wystąpił błąd podczas weryfikacji reCAPTCHA, spróbuj odświeżyć stronę"
              );
              reject();
              return;
            }
            const tempToken = await this.$recaptcha(name);
            resolve(tempToken);
            return;
          } catch (error) {
            iteration++;
            console.error(error);
            await new Promise((res) => setTimeout(res, 100));
          }
        }
      });
    },
    async getAvailableDates() {
      try {
        var vm = this;
        var token = "fakeToken";
        if (vm.reservationConfig.captchaConfig.captchaEnable) {
          token = await vm.getRecaptcha("GetAvailableDaysForOperation");
        }

        if (!this.lastStepId) {
          return;
        }
        var response = await vm.$http.get(
          `Slot/GetAvailableDaysForOperation?companyName=${this.companyName}&lastStepId=${this.lastStepId}&recaptchaToken=${token}`
        );

        vm.vCalendarDates.available = response.data.availableDays;
        vm.vCalendarDates.disable = response.data.disabledDays;
        vm.vCalendarDates.minDate = response.data.minDate;
        vm.vCalendarDates.maxDate = response.data.maxDate;
      } catch (error) {
        this.showCustomMessageBasedOnError(error);
      }
    },
    getPropertiesForSlot() {
      var vm = this;
      vm.properties = [];
      vm.$http
        .get(`Slot/GetPropertiesForSlot`)
        .then((response) => {
          vm.properties = response.data;
          setTimeout(() => {
            vm.$refs.formWizard.$el
              .querySelectorAll(".property-input")
              .forEach((element) => {
                element.style.setProperty(
                  "background",
                  vm.colorsConfig.fifthColor,
                  "important"
                );
                element.style.setProperty(
                  "color",
                  vm.colorsConfig.sixthColor,
                  "important"
                );
              });
          });
        })
        .catch((error) => {});
    },
    getRegulations() {
      var vm = this;
      return vm.$http
        .get(`Configuration/GetRegulations/${vm.companyName}`)
        .then((response) => {
          vm.regulations = response.data;
        });
    },
    anonymousReservation() {
      var vm = this;
      vm.isAnonymous = true;
      vm.errors.clear();
      vm.$refs.formWizard.nextTab();
    },
    clearBlockInterval() {
      clearInterval(this.reservationBlockInterval);
      this.reservationBlockEndIn = 0;
    },
    startTimeInterval() {
      var vm = this;
      clearInterval(vm.reservationBlockInterval);
      vm.reservationBlockEndIn = parseInt(getTokenData().reservationTimeToEnd);
      vm.reservationBlockInterval = setInterval(() => {
        vm.reservationBlockEndIn--;
        if (vm.reservationBlockEndIn <= 0) {
          vm.$refs.reservationTimoutModal.open();
          clearInterval(vm.reservationBlockInterval);
        }
      }, 1000);
    },
    async blockSlot() {
      var vm = this;
      if (!vm.selectedDay) {
        return;
      }
      var captchPromise;
      if (vm.reservationConfig.captchaConfig.captchaEnable) {
        captchPromise = vm.$recaptcha("BlockSlot");
      } else {
        captchPromise = new Promise((resolve) => resolve("fakeToken"));
      }
      var token;
      try {
        token = await captchPromise;
      } catch (error) {
        vm.$refs.messageDialog.show(
          "warn",
          "Wystąpił błąd podczas weryfikacji reCAPTCHA"
        );
        throw error;
      }
      var response;

      try {
        response = await vm.$http.post(`Slot/BlockSlot`, {
          slotId: vm.selectedSlot.id,
          companyName: vm.companyName,
          captchaToken: token,
          captchaV2Token: vm.captchaV2Token,
          blockedBy: 1,
        });
      } catch (error) {
        if (error.response && error.response.data) {
          if (
            error.response.data.toLowerCase() ==
            "limit of reservations for this operation reached"
          ) {
            vm.$refs.messageDialog.show(
              "warn",

              vm.$locales.t(
                "limit_reservation_error",
                "Wykorzystałeś limit swoich rezerwacji do wybranej operacji"
              )
            );
            vm.$refs.hCaptcha?.reset();
            vm.$refs.formWizard.reset();
          } else {
            vm.$refs.messageDialog.show(
              "warn",

              vm.$locales.t(
                "verify_captcha_error",
                "Wystąpił błąd weryfikacji captcha"
              )
            );
            vm.$refs.hCaptcha?.reset();
            vm.$refs.formWizard.reset();
          }
        }
        throw error;
      }

      sessionStorage.setItem("token", response.data.token);
      vm.startTimeInterval();
      await vm.setSmsCodeBeforeConfirmNeeded();
      return token;
    },
    setSmsCodeBeforeConfirmNeeded() {
      var vm = this;
      return vm.$http
        .get("Configuration/CheckSmsCodeBeforeConfirmNeeded")
        .then((response) => {
          vm.smsCodeBeforeConfirmNeeded = response.data;
        });
    },
    getOperation() {
      var vm = this;
      return new Promise((resolve, reject) => {
        vm.$http
          .get(`Operation/GetReservationLocalizations/${vm.companyName}`)
          .then((response) => {
            const any = response.data.some(
              (o) => !o.displayPriorityInReservation
            );

            if (!any) {
              vm.localizations = response.data.sort((a, b) =>
                a.displayPriorityInReservation > b.displayPriorityInReservation
                  ? 1
                  : -1
              );
              resolve();
              return;
            }
            vm.localizations = response.data.sort((a, b) =>
              a.id > b.id ? 1 : -1
            ); //response.data;//
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    getReservationMode() {
      var vm = this;
      return vm.$http
        .get(`Configuration/GetReservationMode/${vm.companyName}`)
        .then((response) => {
          vm.reservationMode = response.data.type;
        })
        .catch(() => {});
    },
    getColorsConfig() {
      var vm = this;
      return new Promise((resolve, reject) => {
        vm.$http
          .get(`Configuration/GetReservationColorsForCompany/${vm.companyName}`)
          .then((response) => {
            vm.colorsConfig = response.data;
            vm.setContrast();
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    beforeLocationChangeTab() {
      return this.selectedLocalization != null;
    },
    beforeQueueChangeTab() {
      return this.selectedQueue != null;
    },
    firstTabSwitch() {
      return this.selectedOperation != null;
    },
    secondTabSwitch() {
      if (
        this.captchaV2Config &&
        !this.captchaV2Token &&
        this.reservationConfig.captchaConfig.captchaEnable
      ) {
        this.$refs.messageDialog.show(
          "warn",
          this.$locales.t(
            "verify_captcha_error",
            "Wystąpił błąd weryfikacji captcha"
          )
        );
        return false;
      }
      return this.selectedSlot != null;
    },
    thirdTabSwitch() {
      var vm = this;
      return this.$validator.validate().then((valid) => {
        if (vm.isAnonymous) {
          return vm.updatePropertiesInfo().then(() => {
            return true;
          });
        } else {
          return vm.updatePropertiesInfo().then(() => {
            vm.isAnonymous = false;
            return valid;
          });
        }
      });
    },
    finishTabSwitch() {
      return (
        (this.acceptRegulations || !this.regulations.mustAccept) &&
        (!this.reservationConfig.sendDocumentMustAccept ||
          this.allowSendDocument)
      );
    },
    async tabSwitch(oldIndex, nextIndex) {
      var vm = this;
      this.currentTabIndex = nextIndex;
      if (oldIndex == this.stepsCount - 2 && nextIndex > oldIndex) {
        vm.blockSlot()
          .then(() => {
            vm.slotBlockedError = "";
            vm.getPropertiesForSlot();
          })
          .catch((error) => {
            if (error.response) {
              if (
                error.respose &&
                error.response.data &&
                error.response.data.toString().toLowerCase() ==
                  "error while verify captcha"
              ) {
                vm.$refs.messageDialog.show(
                  "error",
                  vm.$locales.t(
                    "verify_captcha_error",
                    "Wystąpił błąd weryfikacji captcha"
                  )
                );

                vm.$refs.formWizard.changeTab(
                  this.stepsCount - 1,
                  this.stepsCount - 2
                );
                return;
              }
              if (
                error.response.data.toLowerCase() ==
                "limit of reservations for this operation reached"
              ) {
                vm.$refs.formWizard.changeTab(
                  this.stepsCount - 1,
                  this.stepsCount - 2
                );
                return;
              }
            }
            vm.slotBlockedError = vm.$locales.t(
              "slot_already_reservated",
              "Niestety wybrana data jest już zarezerwowana, prosimy wybrać inną."
            );
            vm.$refs.formWizard.changeTab(
              this.stepsCount - 1,
              this.stepsCount - 2
            );
            vm.refreshSlots();
          });
      }
      if (nextIndex == this.stepsCount - 1) {
        vm.isAnonymous = false;
      }
      if (nextIndex < this.stepsCount - 1 && oldIndex >= this.stepsCount - 1) {
        setTimeout(() => {
          if (vm.$refs.formWizard) {
            vm.$refs.formWizard.reset();
          }
        }, 100);
      }
      if (nextIndex == this.stepsCount - 3 && !vm.isConfirmed) {
        vm.$refs.hCaptcha?.reset();
        await vm.getAvailableDates();
      }
    },
    updatePropertiesInfo() {
      var vm = this;
      return vm.$http
        .post("Slot/UpdateSlotProperties", {
          isAnonymous: vm.isAnonymous,
          properties: vm.properties,
        })
        .then(() => {
          if (vm.smsCodeBeforeConfirmNeeded) {
            vm.sendSmsCode();
          }
        })
        .catch((error) => {
          vm.showCustomMessageBasedOnError(error);
        });
    },
    showCustomMessageBasedOnError(error) {
      const message = error?.response?.data?.toLowerCase()?.trim();
      let type = "warn";
      var vm = this;
      let customMessage = vm.$locales.t(
        "session_end_general_error",
        "Przepraszamy, ale ze wzgledu na wzmożoną aktywność na stronie nie możemy dokończyć rezerwacji. Spróbuj ponownie później"
      );

      if (message) {
        switch (message) {
          case "limit of reservations for this phone number reached": {
            customMessage = vm.$locales.t(
              "phone_number_limit_error",
              "Wykorzystałeś limit rezerwacji na ten numer telefonu"
            );
            if (vm.$refs.formWizard) {
              vm.$refs.formWizard.reset();
            }
            vm.selectedOperation = null;
            vm.clearBlockInterval();
            break;
          }
          case "limit of reservations for this operation reached": {
            customMessage = vm.$locales.t(
              "limit_reservation_error",
              "Wykorzystałeś limit swoich rezerwacji do wybranej operacji"
            );
            if (vm.$refs.formWizard) {
              vm.$refs.formWizard.reset();
            }
            vm.selectedOperation = null;
            vm.clearBlockInterval();
            break;
          }
          case "validator error": {
            customMessage = vm.$locales.t(
              "validate_data_error",
              "Błąd walidacji wprowadzonych danych"
            );
            break;
          }
          case "error while verify captcha": {
            customMessage = vm.$locales.t(
              "verify_captcha_error",
              "Wystąpił błąd weryfikacji captcha"
            );
            break;
          }
          case "properties not unique": {
            customMessage = vm.$locales.t(
              "limit_reservation_error",
              "Wykorzystałeś limit swoich rezerwacji do wybranej operacji"
            );

            if (vm.$refs.formWizard) {
              vm.$refs.formWizard.reset();
            }
            vm.selectedOperation = null;
            vm.clearBlockInterval();
            break;
          }
          case "qb004": {
            customMessage = vm.$locales.t(
              "qb004_error",
              "Błąd QB004, spróbuj ponownie"
            );
            if (vm.$refs.formWizard) {
              vm.$refs.formWizard.reset();
            }
            vm.clearBlockInterval();
            vm.selectedOperation = null;
            break;
          }
          default: {
            customMessage = vm.$locales.t(
              "session_end_general_error",
              "Przepraszamy, ale z powodu zwiększonej aktywności na stronie nie możemy dokończyć rezerwacji. Spróbuj ponownie później"
            );
            if (vm.$refs.formWizard) {
              vm.$refs.formWizard.reset();
            }
            vm.selectedOperation = null;
            vm.clearBlockInterval();
            break;
          }
        }
      }

      vm.showCustomMessage(type, customMessage);
    },
    sendSmsCode() {
      var vm = this;

      vm.$http.post("Slot/SendSmsCode").catch((error) => {
        if (error.response) {
          if (
            error.response.data.toLowerCase() ==
            "cannot send confirm sms code yet"
          ) {
            vm.showCustomMessage(
              "warn",
              vm.$locales.t(
                "sms_code_resend_wait",
                "Twój kod został przed chwilą wysłany, zaczekaj przed ponowieniem próby"
              )
            );
          } else {
            vm.showCustomMessageBasedOnError(error);
          }
        }
      });
    },
    async refreshSlots(day) {
      if (this.reservationConfig.captchaConfig.hCaptchaBeforeCalendar) {
        if (!this.hCapchaTokenBeforeCalendar) {
          this.hCapchaVerifyAction = () => this.refreshSlots(day);
          this.$refs.hCaptchaModal.open();
          return;
        }
      } else {
        this.hCapchaTokenBeforeCalendar = "fakeToken";
      }
      try {
        var vm = this;
        if (!day) {
          day = vm.selectedDay;
        }
        if (!day) {
          return;
        }
        var token = "fakeToken";

        if (vm.reservationConfig.captchaConfig.captchaEnable) {
          token = await vm.$recaptcha("GetAvailableSlotsForOperationAndDay");
        }
        var response = await vm.$http.get(
          `Slot/GetAvailableSlotsForOperationAndDay?companyName=${
            this.companyName
          }&lastStepId=${this.lastStepId}&day=${moment(new Date(day)).format(
            "YYYY-MM-DD"
          )}&recaptchaToken=${token}&hCaptchaToken=${
            this.hCapchaTokenBeforeCalendar
          }`
        );
        vm.availableSlots = response.data;

        vm.selectOptionsSlots = response.data.map((slot) => {
          return {
            value: slot,
            text: slot.dateTime,
          };
        });

        vm.selectOptionsSlots.sort((a, b) => {
          return new Date(a.text) - new Date(b.text);
        });

        vm.selectOptionsSlots.forEach((slot) => {
          slot.text = moment(slot.text).format("HH:mm");
        });

        vm.selectOptionsSlots = Array.from(
          new Set(vm.selectOptionsSlots.map((slot) => slot.text))
        ).map((text) => {
          return {
            value: vm.selectOptionsSlots.find((slot) => slot.text == text)
              .value,
            text: text,
          };
        });
        vm.$refs.timePickerModal.open();
      } catch (error) {
        this.showCustomMessageBasedOnError(error);
      }
      this.hCapchaTokenBeforeCalendar = "";
      this.$refs.hCaptchaBeforeCalendar.reset();
    },
    continueReservation() {
      var vm = this;
      vm.disalbeModalBtn = true;
      vm.$http.get("Slot/CheckSlotIsStillReserved").then((response) => {
        if (response) {
          vm.selectedOperation = getTokenData().operationId;
          vm.$refs.formWizard.nextTab();
          vm.selectedDay = new Date(parseInt(getTokenData().reservationDate));
          vm.$http.get("Slot/GetSlotInfo").then((response) => {
            vm.selectedSlot = response.data;
            vm.$refs.formWizard.nextTab();
            vm.$refs.continueReservationModal.close();
          });
        } else {
          vm.globalError = vm.$locales.t(
            "session_end",
            "Twoja rezerwacja wygasła, stwórz nową"
          );
          vm.$refs.continueReservationModal.close();
        }
      });
    },
    setColors() {
      var vm = this;
      setTimeout(() => {
        if (!vm.isContrast) {
          var css = document.createElement("style");
          css.type = "text/css";
          var styles = `div.vc-highlights div.vc-highlight, .vc-header { background-color: ${vm.colorsConfig.secondColor} !important }`;
          styles += `.vc-header .vc-title, .vc-arrows-container .vc-svg-icon {color:white !important}`;
          styles += `.vc-arrows-container div.vc-flex:focus { background:#252525!important}`;
          styles += `ul.wizard-nav li.active a div, ul.wizard-nav li a span{ color:${vm.colorsConfig.mainTextColor}!important;} ul.wizard-nav li.active a div {background-color: ${vm.colorsConfig.secondColor} !important; color:${vm.colorsConfig.thirdColor}!important;} `;
          if (css.styleSheet) css.styleSheet.cssText = styles;
          else css.appendChild(document.createTextNode(styles));
          var body = document.body.appendChild(css);
        }

        vm.colorsInit = true;
      });
    },
    setContrast() {
      var vm = this;
      switch (vm.contrast) {
        case "black": {
          vm.colorsConfig.backgroundColor = "#252525";
          vm.colorsConfig.mainTextColor = "white";
          vm.colorsConfig.firstColor = "white";
          vm.colorsConfig.secondColor = "white";
          vm.colorsConfig.thirdColor = "black";
          vm.colorsConfig.fourthColor = "black";
          vm.sweetModalStyle = { color: "black" };
          break;
        }
      }
    },
    setCaptchaConfig() {
      var vm = this;
      return vm.$http
        .get("Configuration/GetCaptchaV2?companyName=" + vm.companyName)
        .then((response) => {
          vm.captchaV2Config = response.data;
        });
    },
    setCaptchaV2SiteKey() {
      this.captchaV2SiteKey = captchaV2Key();
    },
    setHCaptchaSiteKey() {
      this.hCaptchaSiteKey = hCaptchaKey();
    },
    async setReservationConfig() {
      var response = await this.$http.get(
        "Configuration/GetReservationConfig/" + this.companyName
      );
      this.reservationConfig = response.data;
    },
    async setReservationSteps() {
      const response = await this.$http.get(
        "Configuration/GetReservationSteps/" + this.companyName
      );
      if (
        !response.data.localization &&
        !response.data.queue &&
        !response.data.operation
      ) {
        response.data.operation = true;
      }

      this.reservationSteps = response.data;
    },
  },
  async mounted() {
    var vm = this;

    vm.setCaptchaV2SiteKey();
    vm.setHCaptchaSiteKey();
    await vm.$http
      .get(`Authentication/GetEmptyToken/${vm.companyName}`)
      .then((response) => {
        sessionStorage.setItem("token", response.data.token);
      });

    await vm.getColorsConfig();
    await vm.getOperation();

    vm.setColors();
    await vm.getRegulations();
    await vm.getReservationMode();
    await vm.setCaptchaConfig();
    await vm.setReservationConfig();
    await vm.setReservationSteps();
    vm.isInitialized = true;
    if (vm.$route.query?.selectedOperation) {
      vm.$nextTick(() => {
        var operationId = parseInt(vm.$route.query?.selectedOperation);
        if (!(operationId > 0)) {
          return;
        }

        if (!vm.operations.find((el) => el.id == operationId)) {
          return;
        }
        vm.selectedOperation = operationId;

        function nextTabLocal() {
          if (vm.isInitialized && vm.$refs.formWizard) {
            vm.$refs.formWizard.nextTab();
          } else {
            setTimeout(() => {
              nextTabLocal();
            }, 50);
          }
        }
        nextTabLocal();
      });
    }
  },
  destroyed() {
    clearInterval(this.reservationBlockInterval);
  },
  updated() {
    setTimeout(() => {
      try {
        var steps = document.getElementsByClassName("wizard-icon-circle");
        throw "test";
        steps?.forEach((el) => {
          el.tabIndex = -1;
        });
      } catch (error) {}
    }, 500);
  },
};
</script>
<style scoped>
.operation-button.active {
  border: 5px solid black !important;
  box-shadow: 0 0 10px white;
}

.operation-button {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

span.property-error {
  color: red;
}

.global-property {
  font-size: 18px;
  padding: 10px;
}

.footer-btn {
  font-size: large;
}

.property-info {
  font-size: 18px;
  padding: 5px;
}

#form-wizard >>> .vdp-datepicker__calendar {
  width: 100% !important;
  box-shadow: 0 0 5px #7c7c7c;
  background-color: inherit;
}

#form-wizard >>> .vdp-datepicker__calendar header span {
  background: #3eb157;
}

#form-wizard >>> li.active .wizard-icon-circle {
  border-color: black !important;
  box-shadow: 0 0 10px white;
}

#form-wizard >>> .wizard-icon-circle .wizard-icon-container {
  border-radius: 50%;
}

#form-wizard >>> div span.cell:not(.disabled),
#form-wizard >>> div span.vc-day-content:not(.vc-pointer-events-none) {
  font-weight: bold;
}

#form-wizard >>> .vc-container {
  width: 100%;
}

#form-wizard >>> .vc-header {
  padding: 10px;
}

#form-wizard >>> i.wizard-icon {
  font-size: 1rem;
}

#form-wizard >>> .wizard-card-footer .footer-btn {
  font-size: 1rem;
}

#form-wizard >>> div.wizard-icon-circle {
  width: 3rem !important;
  height: 3rem !important;
}

#form-wizard >>> .wizard-header {
  display: none !important;
}

.operation-button {
  font-size: 1.2rem;
}

div.text-over-steps >>> img {
  height: auto;
  max-width: 100%;
}
</style>


